import { createRouter, createWebHistory } from 'vue-router'
import type { RouteLocationNormalized } from 'vue-router'
import { API_BASE_URL } from '../lib/runtime-config'

const FORCE_TOP_ROUTE_NAMES = new Set(['Impressum', 'Datenschutz', 'Barrierefreiheit', 'DsarVerify'])
const ADMIN_SESSION_HINT_KEY = 'lf_admin_seen'
const ADMIN_REQUEST_BLOCKED_UNTIL_KEY = 'lf_admin_blocked_until'

const routes = [
  { path: '/', name: 'Home', component: { render: () => null }, meta: { seoTitleKey: 'seo.homeTitle', seoDescriptionKey: 'seo.homeDescription' } },
  { path: '/impressum', name: 'Impressum', component: () => import('../views/impressum.vue'), meta: { seoTitleKey: 'seo.pages.imprintTitle', seoDescriptionKey: 'seo.pages.imprintDescription' } },
  { path: '/datenschutz', name: 'Datenschutz', component: () => import('../views/datenschutz.vue'), meta: { seoTitleKey: 'seo.pages.privacyTitle', seoDescriptionKey: 'seo.pages.privacyDescription' } },
  { path: '/barrierefreiheit', name: 'Barrierefreiheit', component: () => import('../views/barrierefreiheit.vue'), meta: { seoTitleKey: 'seo.pages.accessibilityTitle', seoDescriptionKey: 'seo.pages.accessibilityDescription' } },
  { path: '/dsar/verify', name: 'DsarVerify', component: () => import('../views/dsar-verify.vue'), meta: { seoTitleKey: 'seo.pages.dsarTitle', seoDescriptionKey: 'seo.pages.dsarDescription' } },
  { path: '/case-studies/:slug', name: 'CaseStudy', component: () => import('../views/case-study.vue'), meta: { seoTitleKey: 'seo.pages.caseStudyTitle', seoDescriptionKey: 'seo.pages.caseStudyDescription' } },

  { path: '/blog', name: 'BlogIndex', component: () => import('../views/blog-index.vue'), meta: { seoTitleKey: 'seo.blogTitle', seoDescriptionKey: 'seo.blogDescription' } },
  { path: '/blog/kategorie/:category', name: 'BlogCategory', component: () => import('../views/blog-index.vue'), meta: { seoTitleKey: 'seo.blogTitle', seoDescriptionKey: 'seo.blogDescription' } },
  { path: '/blog/:slug', name: 'BlogDetail', component: () => import('../views/blog-detail.vue'), meta: { seoTitleKey: 'seo.blogTitle', seoDescriptionKey: 'seo.blogDescription' } },
  { path: '/karriere/:slug', name: 'JobDetail', component: () => import('../views/job-detail.vue'), meta: { seoTitleKey: 'seo.homeTitle', seoDescriptionKey: 'seo.homeDescription' } },

  { path: '/admin/login', name: 'AdminLogin', component: () => import('../views/admin-login.vue'), meta: { guestOnly: true, seoTitleKey: 'seo.pages.adminLoginTitle', seoDescriptionKey: 'seo.pages.adminLoginDescription' } },
  { path: '/admin/dashboard', name: 'AdminDashboard', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'analytics', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/posts', name: 'AdminPosts', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'posts', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/posts/new', name: 'AdminPostCreate', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'posts', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/posts/:id/edit', name: 'AdminPostEdit', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'posts', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/categories', name: 'AdminCategories', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'categories', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/authors', name: 'AdminAuthors', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'authors', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/authors/new', name: 'AdminAuthorCreate', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'authors', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/authors/:id/edit', name: 'AdminAuthorEdit', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'authors', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/jobs', name: 'AdminJobs', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'jobs', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/jobs/new', name: 'AdminJobCreate', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'jobs', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/jobs/:id/edit', name: 'AdminJobEdit', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'jobs', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/media', name: 'AdminMedia', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'media', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/dsar', name: 'AdminDsar', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'dsar', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },
  { path: '/admin/contacts', name: 'AdminContacts', component: () => import('../views/admin-posts.vue'), meta: { requiresAdmin: true, adminView: 'contacts', seoTitleKey: 'seo.pages.adminTitle', seoDescriptionKey: 'seo.pages.adminDescription' } },

  { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('../views/not-found.vue'), meta: { seoTitleKey: 'seo.pages.notFoundTitle', seoDescriptionKey: 'seo.pages.notFoundDescription' } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (FORCE_TOP_ROUTE_NAMES.has(String(to.name))) {
      return {
        left: 0,
        top: 0,
        behavior: 'auto',
      }
    }
    if (to.hash) {
      return {
        el: to.hash,
        top: 88,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  },
})

async function hasAdminSession(forceProbe = false): Promise<boolean> {
  if (!forceProbe && typeof window !== 'undefined') {
    const blockedUntil = Number(window.sessionStorage.getItem(ADMIN_REQUEST_BLOCKED_UNTIL_KEY) || '0')
    const hasAdminHint = window.sessionStorage.getItem(ADMIN_SESSION_HINT_KEY) === '1'
    if (blockedUntil > Date.now() || !hasAdminHint) {
      hasAdminSessionCache = {
        value: false,
        expiresAt: 0,
      }
      return false
    }
  }
  const now = Date.now()
  if (hasAdminSessionCache.expiresAt > now) {
    return hasAdminSessionCache.value
  }
  if (hasAdminSessionInFlight) {
    return hasAdminSessionInFlight
  }
  hasAdminSessionInFlight = (async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/auth/me`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })

    if (!response.ok) return false

    const payload = await response.json() as { success?: boolean }
    return payload.success === true
  } catch {
    return false
  } finally {
    hasAdminSessionInFlight = null
  }
  })()

  const result = await hasAdminSessionInFlight
  hasAdminSessionCache = {
    value: result,
    expiresAt: now + 15000,
  }
  return result
}

let hasAdminSessionInFlight: Promise<boolean> | null = null
let hasAdminSessionCache = {
  value: false,
  expiresAt: 0,
}

export function invalidateAdminSessionCache(value?: boolean) {
  hasAdminSessionInFlight = null
  hasAdminSessionCache = {
    value: value ?? false,
    expiresAt: 0,
  }
}

router.beforeEach(async (to: RouteLocationNormalized) => {
  if (to.meta.requiresAdmin) {
    const authorized = await hasAdminSession(true)
    if (!authorized) {
      return {
        name: 'AdminLogin',
        query: to.fullPath !== '/admin/posts' ? { redirect: to.fullPath } : {},
      }
    }
  }

  if (to.meta.guestOnly) {
    if (typeof window !== 'undefined') {
      const blockedUntil = Number(window.sessionStorage.getItem(ADMIN_REQUEST_BLOCKED_UNTIL_KEY) || '0')
      const hasAdminHint = window.sessionStorage.getItem(ADMIN_SESSION_HINT_KEY) === '1'
      if (blockedUntil > Date.now() || !hasAdminHint) {
        return true
      }
    }
    const authorized = await hasAdminSession()
    if (authorized) {
      return { name: 'AdminDashboard' }
    }
  }

  return true
})

router.afterEach((to) => {
  if (!FORCE_TOP_ROUTE_NAMES.has(String(to.name))) return
  requestAnimationFrame(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    })
  })
})

export default router
